import moment from 'moment-timezone'

// IANA timezone sent to report endpoints (dashboard): the user's manual zone
// when the app set a moment default (`moment.tz.setDefault`), else the device
// zone. A function, not a constant — the default zone is set after login.
export const getMomentTimezone = (): string => {
  try {
    return moment().tz() || moment.tz.guess()
  } catch {
    return ''
  }
}
